// NOTICE: KAPTION-INTEGRATION
// Sales Funnel Kanban constants - defines stages, colors, icons, and label prefix

export const FUNNEL_LABEL_PREFIX = 'funnel:';

export const FUNNEL_STAGES = [
  {
    key: 'new_lead',
    label: 'New Lead',
    color: 'kpt-sky',
    colorHex: '#0ea5e9',
    icon: 'i-lucide-user-plus',
  },
  {
    key: 'qualified',
    label: 'Qualified',
    color: 'kpt-indigo',
    colorHex: '#6366f1',
    icon: 'i-lucide-badge-check',
  },
  {
    key: 'proposal',
    label: 'Proposal',
    color: 'kpt-amber',
    colorHex: '#fbbf24',
    icon: 'i-lucide-file-text',
  },
  {
    key: 'won',
    label: 'Won',
    color: 'kpt-emerald',
    colorHex: '#10b981',
    icon: 'i-lucide-trophy',
  },
  {
    key: 'lost',
    label: 'Lost',
    color: 'kpt-text-muted-dark',
    colorHex: '#6b7280',
    icon: 'i-lucide-x-circle',
  },
];

export const FUNNEL_STAGE_KEYS = FUNNEL_STAGES.map(s => s.key);

/**
 * Get the funnel label string for a stage key
 * e.g. 'qualified' -> 'funnel:qualified'
 */
export const getFunnelLabel = stageKey => `${FUNNEL_LABEL_PREFIX}${stageKey}`;

/**
 * Get all funnel label strings
 */
export const ALL_FUNNEL_LABELS = FUNNEL_STAGE_KEYS.map(getFunnelLabel);

/**
 * Extract stage key from a funnel label
 * e.g. 'funnel:qualified' -> 'qualified'
 */
export const getStageFromLabel = label => {
  if (!label || !label.startsWith(FUNNEL_LABEL_PREFIX)) return null;
  return label.slice(FUNNEL_LABEL_PREFIX.length);
};

/**
 * Get stage config by key
 */
export const getStageConfig = key => FUNNEL_STAGES.find(s => s.key === key);

/**
 * Determine which stage a conversation belongs to based on its labels
 * Returns 'new_lead' if no funnel label is found
 */
export const getConversationStage = (conversationLabels = []) => {
  const match = conversationLabels
    .map(getStageFromLabel)
    .find(stage => stage && FUNNEL_STAGE_KEYS.includes(stage));
  return match || 'new_lead';
};
